import { reactive } from 'vue'
import { collectExpandableIds, flattenVisibleFromFlat } from './flatten-visible'
import { resolveTreeConfig } from './tree-config'
import type { DataGridTree } from '../types'

function usesClientPagination($grid: DataGridTree) {
  const { options } = $grid
  return options.loadAll !== false && options.pagination !== false
}

/** 对展开后的可见行做客户端分页（loadAll 模式） */
export function applyClientPagination($grid: DataGridTree) {
  const { reactData, internalData, options } = $grid
  const all = internalData.allTableData

  if (!usesClientPagination($grid)) {
    reactData.tableData = reactive([...all])
    if (options.loadAll !== false) {
      reactData.total = all.length
    }
    return
  }

  reactData.total = all.length
  const maxPage = Math.max(1, Math.ceil(all.length / reactData.pageSize) || 1)
  if (reactData.currentPage > maxPage) {
    reactData.currentPage = maxPage
  }
  const start = (reactData.currentPage - 1) * reactData.pageSize
  reactData.tableData = reactive(all.slice(start, start + reactData.pageSize))
}

export function syncTreeTableData($grid: DataGridTree) {
  const { internalData, options } = $grid
  const treeConfig = resolveTreeConfig(options)
  internalData.allTableData = flattenVisibleFromFlat(
    internalData.flatSource,
    internalData.expandSet,
    treeConfig
  )
  applyClientPagination($grid)
}

export function initExpandSetFromFlat($grid: DataGridTree) {
  const treeConfig = resolveTreeConfig($grid.options)
  $grid.internalData.expandSet = new Set()
  if (!treeConfig.expandAll) {
    return
  }
  const expandable = collectExpandableIds(
    $grid.internalData.flatSource,
    treeConfig
  )
  $grid.internalData.expandSet = expandable
}
